import { FC, useEffect, useState } from "react";
import ExpansionPanel from "../../components/ExpansionPanel/ExpansionPanel";
import css from './Documentation.module.scss';
import { IClassInfo } from "./interfaces/IClassInfo";
import { useFetching } from "../../hooks/useFetching";
import $api from "../../http";
import { useSearch } from "./hooks/useSearch";
import Modal from "../../components/Modal/Modal";
import Button from "../../elements/Button/Button";
import Table from "../../components/Table";

const Documentation: FC = () => {
    const [classInfo, setClassInfo] = useState<IClassInfo[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const searchedInfo = useSearch(classInfo, searchQuery);

    const [projectPath, setProjectPath] = useState<string>('');
    const [path, setPath] = useState<string>('');

    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [isWrongPath, setIsWrongPath] = useState<boolean>(false);

    const [fetchInfo] = useFetching(async () => {
        const response = await $api.get<IClassInfo[]>('/Documentation/Mediator');
        setClassInfo(response.data)
    })

    useEffect(() => {
        fetchInfo()
        setProjectPath(localStorage.getItem('projectPath') || '');
    }, [])

    const getRoles = (): string[] => {
        return [...Array.from(new Set(classInfo.map(el => el.mediatorRole)))];
    }

    const handleOpenFile = (path: string) => {
        if (!projectPath) {
            setModalVisible(true);
        } else {
            window.open(`rider:///${ projectPath }\\${ path }`)
        }

    }

    const handleSavePath = () => {
        const reg = /^[A-Z]:\\.*/gm;

        if (reg.test(path)) {
            localStorage.setItem('projectPath', path)
            setProjectPath(path);
            setModalVisible(false);
        } else {
            setIsWrongPath(true);
        }
    }

    return (
        <div className={ css.wrapper }>
            <div className={ css.searchWrapper }>
                <input type="text" onChange={ (e) => setSearchQuery(e.target.value) } value={ searchQuery }
                       className={ css.searchWrapper__search } placeholder="Search here anything"/>
            </div>
            <div className={ css.contentWrapper }>
                { getRoles().map(el => (
                    <ExpansionPanel className={ css.panel } key={ el } title={ el }>
                        <Table customClass={ css.table }
                               theadData={ ['Class name', 'Project names', 'Description'] }
                               tbodyData={ searchedInfo.filter(c => c.mediatorRole === el).map(el => ({
                                   id: el.projectNames + el.className,
                                   items: [el.className, el.projectNames, el.description],
                                   onClickRow: () => handleOpenFile(el.path)
                               })) }
                        />
                    </ExpansionPanel>
                )) }
                <Modal className={ css.modal } visible={ modalVisible } setVisible={ setModalVisible }>
                    <input className={ css.modal__value } placeholder={ "Copy absolute path to project directory here" }
                           onChange={ (e) => setPath(e.target.value) } value={ path } type="text"/>
                    { isWrongPath && <pre>Wrong path</pre> }
                    <Button onClick={ handleSavePath }>Save</Button>
                </Modal>
            </div>
        </div>
    )
}

export default Documentation